/* Model UI only. No cart, checkout, exchange calculation, or network requests. */
(()=>{
  const start=()=>{
    const page=document.querySelector('#kc-page');
    const picker=page?.querySelector('[data-kc-model-picker]');
    const json=page?.querySelector('[data-kc-models]');
    if(!picker||!json||picker.dataset.ready==='true')return;
    let config;try{config=JSON.parse(json.textContent)}catch{return}
    const options=picker.querySelector('[data-kc-model-options]');
    if(!options||!Array.isArray(config.models)||!config.models.length)return;
    picker.dataset.ready='true';
    const ui=(()=>{try{return JSON.parse(page.querySelector('[data-kc-i18n]')?.textContent||'{}')}catch{return {}}})();
    let originalGallery=[];try{originalGallery=JSON.parse(page.querySelector('[data-gallery-json]')?.textContent||'[]')}catch{}
    const models=config.models.map(raw=>({...config.presets?.[raw.kind],...raw}));
    models.forEach(model=>{if(model.kind==='32')model.gallery=originalGallery.map(image=>({...image}))});
    const role=window.Shopify?.theme?.role;
    const preview=typeof role==='string'&&role!=='main'&&page.dataset.country==='DE'&&page.dataset.currency==='EUR';
    const makeDemoCard=model=>{
      const label=document.createElement('label');label.className='kc-model-card';label.dataset.modelCard='';label.dataset.modelKind=model.kind;
      const input=document.createElement('input');input.className='kc-model-radio';input.type='radio';input.name='kc-model';input.value=model.id;input.dataset.variantId=model.id;
      const inner=document.createElement('span');inner.className='kc-model-card-inner';
      const top=document.createElement('span');top.className='kc-model-card-top';
      const capacity=document.createElement('strong');capacity.textContent=model.capacity;
      const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.classList.add('kc-model-check');svg.setAttribute('width','20');svg.setAttribute('height','20');svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.8');svg.setAttribute('stroke-linecap','round');svg.setAttribute('stroke-linejoin','round');svg.setAttribute('aria-hidden','true');
      const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','m5 12 4 4L19 6');svg.append(path);top.append(capacity,svg);inner.append(top);
      for(const [className,value] of [['kc-model-name',model.cardName],['kc-model-features',model.features],['kc-model-card-price',model.priceText]]){
        const span=document.createElement('span');span.className=className;span.textContent=value||'';if(className==='kc-model-card-price')span.dataset.modelCardPrice='';inner.append(span);
      }
      const stock=document.createElement('span');stock.className='kc-model-card-stock';stock.dataset.modelCardStock='';stock.textContent=config.unavailable||ui.unavailable||'';stock.hidden=model.available;inner.append(stock);
      label.append(input,inner);return label;
    };
    if(preview){
      page.dataset.preview='true';
      models.forEach(model=>{model.priceCents=Number(config.previewPriceCents);model.priceText=config.previewPriceText});
      if(!models.some(model=>model.kind==='16')){
        const demo={...config.presets?.['16'],id:'0',kind:'16',priceCents:Number(config.previewPriceCents),priceText:config.previewPriceText,available:true,demo:true};
        models.unshift(demo);options.prepend(makeDemoCard(demo));
      }
    }
    const radios=()=>[...picker.querySelectorAll('input[name="kc-model"][data-variant-id]')];
    const byId=id=>models.find(model=>String(model.id)===String(id));
    const checked=id=>radios().forEach(radio=>{radio.checked=String(radio.dataset.variantId)===String(id)});
    const syncCards=()=>radios().forEach(radio=>{
      const model=byId(radio.dataset.variantId),card=radio.closest('[data-model-card]');if(!model||!card)return;
      card.querySelector('[data-model-card-price]').textContent=model.priceText;
      const stock=card.querySelector('[data-model-card-stock]');if(stock)stock.hidden=!!model.available;
    });
    let current=null;
    const writeUrl=model=>{
      const url=new URL(location.href);url.searchParams.set('variant',String(model.id));
      history.replaceState(history.state,'',url.pathname+url.search+url.hash);
    };
    const restoreCountryUrl=()=>{
      const country=page.dataset.country;
      if(!/^[A-Z]{2}$/.test(country||''))return;
      const url=new URL(location.href);
      if(url.searchParams.has('country'))return;
      url.searchParams.set('country',country);
      history.replaceState(history.state,'',url.pathname+url.search+url.hash);
    };
    const apply=(model,{initial=false,fromHistory=false}={})=>{
      if(!model)return false;
      const previous=current;
      if(!initial&&previous?.id===model.id){checked(model.id);return true}
      if(!initial){
        const before=new CustomEvent('kc:variant-before-change',{bubbles:true,cancelable:true,detail:{previous,next:model,variant:model}});
        if(!page.dispatchEvent(before)){checked(previous?.id);return false}
      }
      current=model;checked(model.id);
      page.dataset.variant=String(model.id);page.dataset.priceCents=String(model.priceCents);page.dataset.available=String(!!model.available);page.dataset.modelKind=model.kind;
      page.querySelectorAll('[data-price]').forEach(el=>el.textContent=model.priceText);
      const fields={'model-name':'name','model-capacity':'capacity','model-year':'year','model-color':'color','model-frontlight':'frontlight','model-frontlight-mode':'frontlightMode','model-frontlight-desc':'frontlightDesc','model-charging':'charging','model-weight':'weight'};
      for(const [hook,key] of Object.entries(fields))page.querySelectorAll('[data-'+hook+']').forEach(el=>el.textContent=model[key]||'');
      page.querySelectorAll('[data-signature-only]').forEach(el=>el.hidden=model.kind!=='32');
      page.querySelectorAll('[data-checkout]').forEach(button=>{
        button.disabled=!model.available;
        const label=button.querySelector('span');
        const normal=button.hasAttribute('data-primary-checkout')?ui.primary_label:ui.sticky_label;
        if(label)label.textContent=model.available?(normal||label.textContent):(ui.unavailable||config.unavailable||'');
      });
      syncCards();
      if(!initial&&!fromHistory)writeUrl(model);
      page.dispatchEvent(new CustomEvent('kc:variant-change',{bubbles:true,detail:{previous,variant:model,model,gallery:model.gallery,images:model.images,initial}}));
      return true;
    };
    const urlId=new URL(location.href).searchParams.get('variant');
    const first=byId(urlId)||byId(config.selectedId)||byId(config.defaultId)||models.find(model=>model.kind==='16')||models[0];
    apply(first,{initial:true});
    restoreCountryUrl();
    picker.addEventListener('change',event=>{
      const radio=event.target.closest('input[name="kc-model"][data-variant-id]');if(radio&&radio.checked)apply(byId(radio.dataset.variantId));
    });
    window.addEventListener('popstate',()=>{
      const id=new URL(location.href).searchParams.get('variant');apply(byId(id)||byId(config.defaultId)||models.find(model=>model.kind==='16'),{fromHistory:true});
    });
    window.addEventListener('pageshow',()=>{
      const id=new URL(location.href).searchParams.get('variant');apply(byId(id)||current||byId(config.defaultId),{initial:true,fromHistory:true});
      restoreCountryUrl();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
